import React from 'react';

import { AddPluginMenuButton, ToggleButton } from '../../components/buttons';
import { FORMATTING_ORIENTATIONS_SWITCH, PLUGINS_ORIENTATIONS_SWITCH } from './data-hooks';
import styles from './mega-toolbar-scss';

export const megaToolbarItemsRenderers = {
  PLUGINS_ORIENTATION_SWITCH: (toolbarItem: $TSFixMe) => {
    return (
      <div className={styles.pluginsOrientationButton}>
        <ToggleButton
          onClick={(e: $TSFixMe) => toolbarItem.commands?.click(e)}
          toolbarItem={toolbarItem}
          dataHook={PLUGINS_ORIENTATIONS_SWITCH}
        />
      </div>
    );
  },
  PLUGINS_ORIENTATION_SWITCH_OPEN: (toolbarItem: $TSFixMe) => {
    return (
      <div className={styles.pluginsOrientationButton}>
        <ToggleButton
          onClick={(e: $TSFixMe) => toolbarItem.commands?.click(e)}
          toolbarItem={toolbarItem}
          dataHook={PLUGINS_ORIENTATIONS_SWITCH}
        />
      </div>
    );
  },
  FORMATTING_ORIENTATION_SWITCH: (toolbarItem: $TSFixMe) => {
    return (
      <div className={styles.formattingOrientationButton}>
        <ToggleButton
          onClick={(e: $TSFixMe) => toolbarItem.commands?.click(e)}
          toolbarItem={toolbarItem}
          dataHook={FORMATTING_ORIENTATIONS_SWITCH}
        />
      </div>
    );
  },
  FORMATTING_ORIENTATION_SWITCH_OPEN: (toolbarItem: $TSFixMe) => {
    return (
      <div className={styles.formattingOrientationButton}>
        <ToggleButton
          onClick={(e: $TSFixMe) => toolbarItem.commands?.click(e)}
          toolbarItem={toolbarItem}
          dataHook={FORMATTING_ORIENTATIONS_SWITCH}
        />
      </div>
    );
  },
  FORMATTING_ORIENTATION_SWITCH_ADD_MENU: (toolbarItem: $TSFixMe) => {
    return <AddPluginMenuButton toolbarItem={toolbarItem} />;
  },
};
